import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.983 5.458a1.31 1.31 0 0 0 1.213-.8c.097-.243.133-.498.072-.753a1.3 1.3 0 0 0-.351-.667 1.295 1.295 0 0 0-1.42-.291 1.3 1.3 0 0 0-.594.485 1.3 1.3 0 0 0-.218.728 1.304 1.304 0 0 0 1.298 1.31zm1.104.934H3.89v7.096h2.196zm4.852 1.783c-.874 0-1.335.594-1.335 1.589V13.5h-2.11V6.392h2.11v.958a2.4 2.4 0 0 1 .91-.873c.376-.206.8-.303 1.225-.303 1.504 0 2.584.921 2.584 2.826v4.5h-2.184V9.764c0-1.019-.388-1.589-1.2-1.589" fill="currentColor"/>' }
  })
);